// Minimal toast queue — one at a time. Replaces an existing toast if a new
// one comes in fast.

import { useCallback, useState } from 'react';
import type { ToastMessage } from '@/components/ui/Toast';

let nextId = 1;

export function useToast() {
  const [toast, setToast] = useState<ToastMessage | null>(null);

  const push = useCallback((text: string, tone?: ToastMessage['tone']) => {
    setToast({ id: nextId++, text, ...(tone ? { tone } : {}) });
  }, []);

  const dismiss = useCallback(() => setToast(null), []);

  return { toast, push, dismiss };
}
